import KeyboardEvents from 'editor/components/KeyboardEvents';
import { KeyboardEventArgs } from './index';

const textKeyboardEvents = {
  keydown: ({ evt, world }: KeyboardEventArgs): void => {
    world.grabAll(KeyboardEvents).forEach(({ component }) => {
      component.emit('keydown', { evt });
    });
  },

  keyup: ({ evt, world }: KeyboardEventArgs): void => {
    world.grabAll(KeyboardEvents).forEach(({ component }) => {
      component.emit('keyup', { evt });
    });
  },
};

export default textKeyboardEvents;
